<template>
  <div id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div id="left-side" >
            <ul>
              <li><a href="#section1">一、引言</a></li>
              <li><a href="#section2">二、安装与配置</a></li>
              <li><a href="#section3">三、用户指南</a></li>
              <li><a href="#section4">四、加密算法</a></li>
            </ul>
          </div>
        <div class="content-wrap">
          <div class="header">
            <h1>一种云盘加密存储方案</h1>
          </div>
          <div class="content">
            <div id="section1">
              <h4>一、引言</h4>
              <h5>1.简介</h5>
              <p class="descrip">Cryptomator是一款开源的加密工具，旨在为用户提供安全可靠的云存储解决方案。它允许用户在本地对文件进行加密，然后再将加密后的文件上传到云存储服务中，确保文件在上传和存储过程中得到保护，只有用户可以解密和访问这些文件。</p>
              <p>主要有以下特点和功能：</p>
              <p>强大的加密：使用先进的加密算法，如AES加密，确保用户的文件和数据得到高强度的保护。每个文件都被单独加密，即使存储在云端，也能保持数据的私密性。</p>
              <p>用户友好的界面：提供直观简单的用户界面，使用户可以轻松创建和管理加密容器。用户可以在加密容器中组织和管理文件，就像普通文件夹一样。</p>
              <p>跨平台支持：支持多种操作系统，包括Windows、MacOS、Linux、Android和iOS，用户可以在不同设备上访问和管理加密文件。</p>
              <p>透明的操作：加密和解密操作对用户是透明的，用户只需输入解锁密码即可访问和编辑加密文件，而无需额外的复杂操作。</p>
              <p>开源：Cryptomator是一个开源项目，其源代码公开且可审查，这增加了软件的透明度和安全性，使用户可以放心使用。</p>
              <h5>2.背景</h5>
              <p class="descrip">在我们的科研、教学、学习和生活中，随着云盘的普及，越来越多的师生开始使用云盘来保存大量的数据和资料。虽然大多数云盘都提供相应的安全机制，但互联网从来没有绝对的安全，一旦重要的资料信息被泄露，将会造成不可预估的后果。因此，确保在校内使用云盘实现高效安全的云存储成为迫切需求。</p>
              <h5>3.目的</h5>
              <p class="descrip">本文将着重介绍睿客云盘与Cryptomator的联合使用，为师生提供更加可靠的云存储解决方案。睿客云盘作为校内专属云存储平台，将为师生提供便捷的数据上传、下载和分享服务。同时，通过引入Cryptomator这一开源加密工具，可以在本地对文件进行加密，然后再上传到哈哈云盘，从而保障数据的安全性和隐私性。</p>
              <p class="descrip">结合睿客云盘和Cryptomator的使用，本文将重点强调数据保密和防护措施，确保敏感资料不会被未经授权的人员访问或泄露。同时，我们也将详细介绍Cryptomator的技术细节和加密算法，让师生对其加密机制有更深入的了解。</p>
              <p class="descrip">通过这一解决方案，师生可以在睿客云盘上高效地管理和共享资料，而不必担心数据安全问题。这种高效安全的云存储方式将为校内师生提供更便捷、可靠的数据存储和管理平台，促进科研、教学和学习的发展。</p>
            </div>
            <div id="section2">
              <h4>二、安装与配置</h4>
              <h5>1.系统需求</h5>
              <p class="descrip">操作系统：Windows 7、Windows 8、Windows 8.1、Windows 10 或更高版本、macOS 10.11（El Capitan）或更高版本。</p>
              <p class="descrip">内存：至少2GB RAM。</p>
              <p class="descrip">硬盘空间：安装程序大小约100MB，加密文件的实际占用空间取决于文件数量和大小。</p>
              <em class="descrip">注：这里只列出了Windows、Mac OS的系统需求，关于Linux、Android、IOS等其他系统请参考官方网站说明。</em>
              <h5>2.安装指南</h5>
              <p class="descrip">前往Cryptomator官方网站（<a href="https://cryptomator.org/downloads/" target="_blank">https://cryptomator.org/downloads/</a>）下载对应操作系统版本的安装程序。</p>
              <p class="descrip">运行下载的安装程序，按照安装向导的指示完成安装。</p>
              <h5>3.其他说明</h5>
              <p class="descrip">在安装Cryptomator客户端时，您可以选择是否安装Dokany Library。Cryptomator在创建资料库时默认选择WebDAV方式，但用户可以主动选择Dokany方式，官方推荐使用Dokany。</p>
              <p class="descrip">WebDAV相对较为稳定，但它有最大单个文件限制，即每个文件最大为4GB。</p>
              <p class="descrip">Dokany文件大小不受限制、速度更快、与操作系统集成度更高，但高负载情况下可能出现崩溃或不稳定现象。</p>
              <p class="descrip">WebDAV和Dokany是Cryptomator支持的两种不同文件系统协议。关于这两种协议，您可以通过官方文档进一步了解：</p>
              <p class="descrip">WebDAV：<a href="http://www.webdav.org/" target="_blank">http://www.webdav.org/</a></p>
              <p class="descrip">Dokany:<a href="http://www.webdav.org/" target="_blank">http://dokan-dev.github.io/</a></p>
            </div>
            <div id="section3">
              <h4>三、用户指南</h4>
              <h5>1.创建“资料库”</h5>
              <p class="descrip">1）打开Cryptomator的客户端，点击“创建新资料库”。</p>
              <p class="center"><img src="@/assets/images/c1.png" alt /></p>
              <br/>
              <p class="descrip">2）选择资料库的保存位置并输入资料库名称，本次演示选择了E盘，命名为“我的第一个保险箱”，点击保存，此时会在E盘创建文件夹，后返回Cryptomator页面。</p>
              <p class="center"><img src="@/assets/images/c2.png" alt /></p>
              <br/>
              <p class="descrip">3）在这里需要设置“资料库密码”，设置完成后，点击创建资料，即可已完成资料库创建。注：通过大、小写字母、数字、特殊符号的组合，可以创建复杂密码。另外若该密码遗失，存储在该资料库的资料将无法找回。</p>
              <p class="center"><img src="@/assets/images/c3.png" alt /></p>
              <br/>
              <h5>2.保存资料</h5>
              <p class="descrip">1）资料库创建完成，输入密码，点击解锁资料库即可打开“资料库”；你也可以在更多选项中设置“记住密码”和其他显示设置。</p>
              <p class="center"><img src="@/assets/images/c4.png" alt /></p>
              <br/>
              <p class="descrip">2）此时Cryptomator的页面会显示当前资料库的吞吐量曲线，同时还会自动打开一个文件夹，这个文件夹就是已经被打开的“资料库”。</p>
              <p class="center"><img src="@/assets/images/c5.png" alt /></p>
              <br/>
              <p class="center"><img src="@/assets/images/c6.png" alt /></p>
              <br/>
              <p class="descrip">3）我们向资料库中分别拷贝存放一些图片、文档和视频。</p>
              <p class="center"><img src="@/assets/images/c7.png" alt /></p>
              <br/>
              <p class="center"><img src="@/assets/images/c8.png" alt /></p>
              <br/>
              <p class="descrip">4）当完成存储后，点击“锁定资料库”，文件夹会自动关闭，Cryptomator会返回资料库密码输入界面。</p>
              <p class="center"><img src="@/assets/images/c9.png" alt /></p>
              <br/>
              <h5>3.查阅资料</h5>
              <p class="descrip">1）通过直接访问“资料库”所在文件夹，将会发现文件已被加密存储。（加密过程和原理请查阅官方文档：<a href="https://cryptomator.org/security/architecture/" target="_blank">https://cryptomator.org/security/architecture/</a>）。</p>
              <p class="center"><img src="@/assets/images/c10.png" alt /></p>
              <br/>
              <p class="descrip">2）如果希望查阅资料，请在Cryptomator页面输入资料库密码，点击解锁资料库即可。</p>
              <p class="center"><img src="@/assets/images/c11.png" alt /></p>
              <br/>
              <h5>4.移动资料库</h5>
              <p class="descrip">1）我们可以选择将资料库保存在睿客云盘，打开睿客云盘，登录后选择我的云盘，点击上传——>上传文件夹，选择上文创建的资料库。</p>
              <p class="center"><img src="@/assets/images/c12.png" alt /></p>
              <br/>
              <p class="center"><img src="@/assets/images/c13.png" alt /></p>
              <br/>
              <p class="descrip">2）完成同步后可以看到“资料库”已被上传，当然你也可以选择通过可移动设备或是其他云盘来保存/同步加密的资料库。</p>
              <p class="center"><img src="@/assets/images/c14.png" alt /></p>
              <br/>
              <h5>4.更换设备访问加密资料</h5>
              <p>在这里笔者将通过另外一部Windows电脑访问上文中加密的资料，同样在访问之前，需要在该电脑上完成睿客云盘和Cryptomator客户端的安装工作。</p>
              <p class="descrip">1）首先打开睿客云盘，登录账号，将我的第一个保险箱下载至本地。</p>
              <p class="descrip">2）打开Cryptomator，选择“打开现有资料库”，并选择对应文件夹中的“masterkey.cryptomator”文件，确认后打开“资料库”。</p>
              <p class="center"><img src="@/assets/images/c15.png" alt /></p>
              <br/>
              <em class="descrip">注：这里只列出了Windows、Mac OS的系统需求，关于Linux、Android、IOS等其他系统请参考官方网站说明。</em>
            </div>
            <div id="section4">
              <h4>四、加密算法</h4>
              <h5>1.对称加密</h5>
              <p class="descrip">使用AES (Advanced Encryption Standard) 作为文件加密的对称加密算法。AES是一种被广泛应用的加密算法，其安全性和性能得到了广泛认可。Cryptomator使用AES-256，即使用256位密钥长度来加密文件，提供高强度的保护。</p>
              <h5>2.PBKDF2 (Password-Based Key Derivation Function 2)</h5>
              <p class="descrip">用于从用户输入的解锁密码派生出加密和解密文件时所需的密钥。PBKDF2能够增加攻击者猜解密码的难度，提高系统的安全性。</p>
              <h5>3.文件名和路径加密</h5>
              <p class="descrip">对文件名和路径进行加密，以确保文件和目录的名称不会暴露敏感信息。</p>
              <h5>4.文件加密容器</h5>
              <p class="descrip">将用户的所有文件加密存储在一个加密容器中。这个容器由Cryptomator管理，其中包含了所有加密文件和相关元数据。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Encryption",
  created() {
    this.$store.commit("SET_THEME", "加密方案");
  },
  mounted() {
    const sidebarLinks = document.querySelectorAll('#left-side ul li a');
    // 监听页面滚动事件
    window.addEventListener('scroll', function() {
      // 获取页面滚动位置
      const scrollPosition = window.scrollY;
      // 遍历每个导航项，检查对应主体板块的位置
      sidebarLinks.forEach(link => {
        const target = document.querySelector(link.getAttribute('href')); // 获取目标板块的元素
        const targetTop = target.getBoundingClientRect().top; // 获取目标板块的相对顶部距离
        const headerHeight = 10; // 顶部标题的高度，根据实际情况调整
        const offset = targetTop - headerHeight; // 考虑标题高度的偏移量
        console.log(target.clientHeight)
        // 如果当前滚动位置在目标板块范围内，高亮显示对应导航项
        if (scrollPosition >= offset && scrollPosition < offset + target.clientHeight) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    });
  }
}
</script>

<style scoped>
@media (max-width: 768px) {
  img {
    width: 100%;
  }
}
h4{
  font-weight: 800;
  line-height: 190%;
  font-size: 28px;
}
h5{
  font-size: 18px;
  font-weight: 800;
  margin: 10px 20px;
}
.content p{
  line-height: 170%;
  margin: 0px 20px;
  font-size: 18px;
  /* text-indent: 2em; */
}
.content p.descrip{
  text-indent: 4rem;
}
.content em.descrip{
  text-indent: 2rem;
  font-size: 16px;
  display: block;
  line-height: 180%;
}
.content p.center{
  text-align: center;
}
#left-side {
      position: fixed;
      font-size: 18px;
      top: 10%;
      left: 81%;
      width: 200px;
      text-align: left;
      
    }
    #left-side ul{
      list-style: none;
        padding: 0;
      
    }
    #left-side ul li {
        height: 35px;
        line-height: 35px;
        font-weight: 800;
      }
    .active{
      color:blue;
    }
</style>